export const projectsList = (state) => state.project.list;
export const projectDetails = (state) => state.project.details;
export const projectIsFetched = (state) => state.project.isFetched;
export const projectIsFetching = (state) => state.project.isFetching;
export const selectedProjectId = (state) => state.checklists.selectedProjectId;


export const location = (state) => {
    return [state.locations.projectsLocation[state.checklists.selectedProjectId]]
}
